const defaultPasswordType = 'password'
const altPasswordType = 'text'

const passwordIconOpen = '/files/flash/images/svg-icons/icon-password-open.svg'
const passwordIconClose = '/files/flash/images/svg-icons/icon-password-close.svg'

export default function showHidePassword () {
  return {
    data () {
      return {
        passwordType: defaultPasswordType,
        passwordIcon: passwordIconOpen,
        passwordRepeatType: defaultPasswordType,
        passwordRepeatIcon: passwordIconOpen
      }
    },
    methods: {
      togglePasswordVisibility (inputType) {
        const icon = inputType === 'repeat' ? 'passwordRepeatIcon' : 'passwordIcon'
        const type = inputType === 'repeat' ? 'passwordRepeatType' : 'passwordType'

        this[icon] = this[type] === defaultPasswordType ? passwordIconClose : passwordIconOpen
        this[type] = this[type] === defaultPasswordType ? altPasswordType : defaultPasswordType
      }
    }
  }
}
